export default "__VITE_ASSET__D3Y$zFkz__"